const NAMESPACE = "pvShowStorageEquipmentDialog";

const KEYS = {
    showStorageEquipmentOptionLabelText: "showStorageEquipmentOptionLabelText",
    showStorageEquipmentNeverOptionText: "showStorageEquipmentNeverOptionText",
    showStorageEquipmentAlwaysOptionText: "showStorageEquipmentAlwaysOptionText",
    showStorageEquipmentFormulaOptionText: "showStorageEquipmentFormulaOptionText",
    selectedFormulaIdAltLabel: "selectedFormulaIdAltLabel",
    formulaDiagramHeaderLabelText: "formulaDiagramHeaderLabelText",
    formulaSelectDefaultOptionText: "formulaSelectDefaultOptionText",
    formulaRequiredValidationErrorMessage: "formulaRequiredValidationErrorMessage"
};

const MESSAGES = {
    [KEYS.showStorageEquipmentOptionLabelText]: {
        value: "When should storage equipment be available in this PV system?",
        comment: "Label for the Never, Always or Formula radio button selector for PV storage equpiment."
    },
    [KEYS.showStorageEquipmentNeverOptionText]: {
        value: "Never",
        comment: "Text for the radio button option that indicates storage equipment should never be available."
    },
    [KEYS.showStorageEquipmentAlwaysOptionText]: {
        value: "Always",
        comment: "Text for the radio button option that indicates storage equipment should always be available."
    },
    [KEYS.showStorageEquipmentFormulaOptionText]: {
        value: "When this formula is true for the project:",
        comment:
            "Text for the radio button option that indicates storage equipment should be available based on a formula."
    },
    [KEYS.selectedFormulaIdAltLabel]: {
        value: "Select a formula",
        comment: "Alt-label for the formula selector in the Show Storage Equipment dialog."
    },
    [KEYS.formulaDiagramHeaderLabelText]: {
        value: "Formula",
        comment:
            "Text that appears above the display of the formula diagram. This area helps the user identify the logic that will be used " +
            "when a particular formula is selected."
    },
    [KEYS.formulaSelectDefaultOptionText]: {
        value: "Select a formula...",
        comment:
            "Default 'Select' placeholder option when user is choosing a formula from a dropdown to use to determine availability of PV storage equipment."
    },
    [KEYS.formulaRequiredValidationErrorMessage]: {
        value: "Please select a formula.",
        comment: "Error message shown when the user has not selected a formula for showing storage equipment."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
